import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { BonusSection } from '../components/BonusSection';
import { AudienceSection } from '../components/AudienceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { UpsellSection } from '../components/UpsellSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900" data-id="element-393">
      <main data-id="element-394">
        <HeroSection data-id="element-395" />
        <ProblemSection data-id="element-396" />
        <SolutionSection data-id="element-397" />
        <ContentSection data-id="element-398" />
        <BonusSection data-id="element-399" />
        <AudienceSection data-id="element-400" />
        <TestimonialsSection data-id="element-401" />
        <UpsellSection data-id="element-402" />
        <PricingSection data-id="element-403" />
        <FAQSection data-id="element-404" />
        <FinalCTASection data-id="element-405" />
      </main>
      <Footer data-id="element-406" />
    </div>;
}